type Currency = { code: string; symbol: string, en: string; es: string; fr: string, it: string; de: string };

export const currencies: Currency[] = [
  { code: "CHF", symbol: "CHF", en: "Swiss Franc", es: "Franco Suizo", fr: "Franc Suisse", it: "Franco Svizzero", de: "Schweizer Franken" },
  { code: "EUR", symbol: "€", en: "Euro", es: "Euro", fr: "Euro", it: "Euro", de: "Euro" },
  { code: "USD", symbol: "$", en: "US Dollar", es: "Dólar Estadounidense", fr: "Dollar Américain", it: "Dollaro Statunitense", de: "US-Dollar" },
  { code: "GBP", symbol: "£", en: "British Pound", es: "Libra esterlina", fr: "Livre sterling", it: "Sterlina Britannica", de: "Britisches Pfund" },
]
